import { takeLatest, put, all, call } from 'redux-saga/effects';

import api from '~/services/api';
import i18n from '~/translations/i18n';

import { toast } from '~/components/CustomToast';

import * as actions from './actions';
import types from './types';

export function* fetchIvrAIAgentFunctions() {
  try {
    const { data } = yield call(api.get, `/v3/ivr/ai-agent/functions`);

    yield put(actions.fetchIvrAIAgentFunctionsSuccess(data));
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_fetching_the_functions')
    );
    yield put(actions.fetchIvrAIAgentFunctionsFailure());
  }
}

export function* searchIvrAIAgentFunctions({ payload }) {
  try {
    const { page, limit, search } = payload;
    const { data } = yield call(api.get, `/v3/ivr/ai-agent/functions/search`, {
      params: { page, limit, search },
    });

    yield put(actions.searchIvrAIAgentFunctionsSuccess(data));
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_fetching_the_functions')
    );
    yield put(actions.searchIvrAIAgentFunctionsFailure());
  }
}

export function* createIvrAIAgentFunction({ payload }) {
  try {
    const { data, callback } = payload;

    const response = yield call(api.post, `/v3/ivr/ai-agent/functions`, data);

    yield put(actions.createIvrAIAgentFunctionSuccess(response.data));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error_error_there_was_an_error_creating_the_function')
    );
    yield put(actions.createIvrAIAgentFunctionFailure());
  }
}

export function* updateIvrAIAgentFunction({ payload }) {
  try {
    const { data, callback } = payload;

    const response = yield call(
      api.put,
      `/v3/ivr/ai-agent/functions/${data?._id}`,
      data
    );

    yield put(actions.updateIvrAIAgentFunctionSuccess(response.data));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_updating_the_function')
    );
    yield put(actions.updateIvrAIAgentFunctionFailure());
  }
}

export function* deleteIvrAIAgentFunction({ payload }) {
  try {
    const { id, callback } = payload;

    yield call(api.delete, `/v3/ivr/ai-agent/functions/${id}`);

    yield put(actions.deleteIvrAIAgentFunctionSuccess(id));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_deleting_the_function')
    );
    yield put(actions.deleteIvrAIAgentFunctionFailure());
  }
}

export function* fetchIvrAIAgentInstructions() {
  try {
    const { data } = yield call(api.get, `/v3/ivr/ai-agent/instructions`);

    yield put(actions.fetchIvrAIAgentInstructionsSuccess(data));
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_listing_instructions')
    );
    yield put(actions.fetchIvrAIAgentInstructionsFailure());
  }
}

export function* searchIvrAIAgentInstructions({ payload }) {
  try {
    const { page, limit, search } = payload;
    const { data } = yield call(
      api.get,
      `/v3/ivr/ai-agent/instructions/search`,
      {
        params: { page, limit, search },
      }
    );

    yield put(actions.searchIvrAIAgentInstructionsSuccess(data));
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_listing_instructions')
    );
    yield put(actions.searchIvrAIAgentInstructionsFailure());
  }
}

export function* createIvrAIAgentInstruction({ payload }) {
  try {
    const { data, callback } = payload;

    const response = yield call(
      api.post,
      `/v3/ivr/ai-agent/instructions`,
      data
    );

    yield put(actions.createIvrAIAgentInstructionSuccess(response.data));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_creating_the_instruction')
    );
    yield put(actions.createIvrAIAgentInstructionFailure());
  }
}

export function* updateIvrAIAgentInstruction({ payload }) {
  try {
    const { data, callback } = payload;

    const response = yield call(
      api.put,
      `/v3/ivr/ai-agent/instructions/${data?._id}`,
      data
    );

    yield put(actions.updateIvrAIAgentInstructionSuccess(response.data));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_updating_the_instruction')
    );
    yield put(actions.updateIvrAIAgentInstructionFailure());
  }
}

export function* deleteIvrAIAgentInstruction({ payload }) {
  try {
    const { id, callback } = payload;

    yield call(api.delete, `/v3/ivr/ai-agent/instructions/${id}`);

    yield put(actions.deleteIvrAIAgentInstructionSuccess(id));

    callback?.();
  } catch (e) {
    toast.error(
      i18n.t('error.oops'),
      i18n.t('error.error_there_was_an_error_deleting_the_instruction')
    );
    yield put(actions.deleteIvrAIAgentInstructionFailure());
  }
}

export default all([
  takeLatest(types.FETCH_IVR_AI_AGENT_FUNCTIONS, fetchIvrAIAgentFunctions),
  takeLatest(types.SEARCH_IVR_AI_AGENT_FUNCTIONS, searchIvrAIAgentFunctions),
  takeLatest(types.CREATE_IVR_AI_AGENT_FUNCTION, createIvrAIAgentFunction),
  takeLatest(types.UPDATE_IVR_AI_AGENT_FUNCTION, updateIvrAIAgentFunction),
  takeLatest(types.DELETE_IVR_AI_AGENT_FUNCTION, deleteIvrAIAgentFunction),
  takeLatest(
    types.FETCH_IVR_AI_AGENT_INSTRUCTIONS,
    fetchIvrAIAgentInstructions
  ),
  takeLatest(
    types.SEARCH_IVR_AI_AGENT_INSTRUCTIONS,
    searchIvrAIAgentInstructions
  ),
  takeLatest(
    types.CREATE_IVR_AI_AGENT_INSTRUCTION,
    createIvrAIAgentInstruction
  ),
  takeLatest(
    types.UPDATE_IVR_AI_AGENT_INSTRUCTION,
    updateIvrAIAgentInstruction
  ),
  takeLatest(
    types.DELETE_IVR_AI_AGENT_INSTRUCTION,
    deleteIvrAIAgentInstruction
  ),
]);
